/* eslint-disable import/first */

// Convert our old gulp setup into webpack 4
export interface IEnvironment {
  debug: boolean;
  development: boolean;
}
declare const ENV: IEnvironment;

if (ENV.development && window.console) {
  // tslint-disable-next-line no-console
  console.warn('Build is in development mode!');
}

// Extend String and jQuery objects
import DexeroJQueryExtensions from './DexeroJQueryExtensions';
DexeroJQueryExtensions(jQuery);

// Create DexeroCoreApp
import DexeroCore from './DexeroCore';
const DexeroCoreApp = Object.create(DexeroCore);

// Create AccessibleDatePicker Object
import AccessibleDatePicker from './AccessibleDatePicker';
const AccessibleDatePickerModule = Object.create(AccessibleDatePicker);
window.AccessibleDatePickerModule = AccessibleDatePickerModule;

// Swagger methods
import DexeroSwagger from './DexeroSwagger';
Object.assign(DexeroCoreApp, DexeroSwagger);

// URL Helpers
import DexeroUrlHelpers from './DexeroUrlHelpers';
Object.assign(DexeroCoreApp, DexeroUrlHelpers);

// General functional helpers
import DexeroGeneralHelpers from './DexeroGeneralHelpers';
Object.assign(DexeroCoreApp, DexeroGeneralHelpers);

// Functions related to modal interactions
import DexeroModals from './DexeroModals';
Object.assign(DexeroCoreApp, DexeroModals);

DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._modalBindings);

// Form functions
import DexeroForm from './DexeroForm';
Object.assign(DexeroCoreApp, DexeroForm);
import inlineEditBindings from './DexeroApp/inlineEdit';

DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._formBindings);
if (window.isFormPage) {
  DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._initFieldsFormlinkWithChilds);
  DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._initGeneratePostJson);
  DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._initPasswordFields);
  DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._initTooltips);
  DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._initWYSIWYG);
}
DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._autolocateLocationFields);
DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._datepickers);
DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._initRadioUnCheck);
DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._initReCaptchaFields);
DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._initSignatureFields);
DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._maskCustomFields);
DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._maskDecimalFields);
DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._maskMoneyFields);
DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._maskNumberFields);
DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._maskPercentFields);
DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._maskPhoneNumbers);
DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._maskPosteNumbers);
DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._maskZipCodes);
DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._textAreaCharCounter);
DexeroCoreApp.initFunctionsArr.push(inlineEditBindings);
DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp.subformQuickFilterBindings);
DexeroCoreApp.subscribe('/subform/inlineEdit/change/', DexeroCoreApp.onSubformInlineEdit);
DexeroCoreApp.subscribe('/subform/updated', DexeroCoreApp.onSubformAjaxEdit);

// Logic Rules
import DexeroFormLogicRules from './DexeroFormLogicRules';
Object.assign(DexeroCoreApp, DexeroFormLogicRules);
if (window.isFormPage) {
  // console.warn('***** TEMP OVERRIDE!!!!!!!!!!!!!!! *****');
  // $(document).ready(() => {
  //   const $fields = $('[data-fire-field-actions]');
  //   console.log($fields);
  //   $fields.data('fire-field-actions', 'true').attr('data-fire-field-actions', 'true');
  // });

  DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp.loadLogicRules);
  DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp.applyLogicOnJsonTableFields);
}

// External sources
import DexeroFormExternalSources from './DexeroFormExternalSources';
Object.assign(DexeroCoreApp, DexeroFormExternalSources);
if (window.isFormPage) {
  DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp.loadExternalSources);
}

// General UI Interactions
import DexeroUiInteractions from './DexeroUiInteractions';
Object.assign(DexeroCoreApp, DexeroUiInteractions);
DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._dexeroUiInteractionsBindings);
DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp.initLogoutTimer);

// Form Validation
import DexeroFormValidation from './DexeroFormValidation';
Object.assign(DexeroCoreApp, DexeroFormValidation);
DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp.handleValidation);

// Help module
import DexeroHelp from './DexeroHelp';
Object.assign(DexeroCoreApp, DexeroHelp);
DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp._helpBindings);
DexeroCoreApp.initFunctionsArr.push(DexeroCoreApp.initHelp);

if (window.debug) {
  console.warn('NEW SCRIPTS ARE ACTIVE! UPDATE: 2022-07-20');
}

window.DexeroCoreApp = DexeroCoreApp;

export default DexeroCoreApp;
